import { Injectable } from '@angular/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

@Injectable({
    providedIn: 'root'
})
export class PictureService {
    constructor() {}

    async getImage(choose?: boolean) {
        try {
            const image = await Camera.getPhoto({
                quality: 100,
                width: 1000,
                height: 1000,
                allowEditing: false,
                resultType: CameraResultType.Base64,
                source: choose ? CameraSource.Photos : CameraSource.Camera
            });
            return image.base64String;
        } catch (error) {
            console.error(error);
            return null;
        }
    }
}
